import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is Goodys Streams?',
      answer: 'Goodys Streams is a digital media support service provider that offers comprehensive device setup, app configuration, and entertainment system optimization. We provide expert technical assistance for all your home entertainment devices, ensuring seamless performance with no technical issues or interruptions.'
    },
    {
      question: 'What services do you provide?',
      answer: 'We provide professional digital media support services including device configuration, app installation assistance, entertainment system optimization, technical troubleshooting, and ongoing maintenance support for all your home entertainment devices.'
    },
    {
      question: 'How does it work?',
      answer: 'Getting started with Goodys Streams is simple and can be done in a few minutes. #1 Ordering: Once you place your order, you\'ll instantly receive your access credentials and setup instructions via email. #2 Installation: Follow our configuration guidelines for each device, or let our support team assist you. #3 Enjoy: Experience optimized entertainment on any device of your choice.'
    },
    {
      question: 'What Payment Methods Are Accepted?',
      answer: 'You can purchase a Goodys Streams subscription using various payment methods including credit card (Visa, MasterCard, Discover, American Express), debit card, PayPal, or wire transfer. If you prefer to use Cryptocurrency or any other payment method, please reach out to us via chat for additional support.'
    },
    {
      question: 'What devices do you support?',
      answer: 'Our service supports all existing devices and platforms on the market. We\'ll provide you with the necessary assistance to get your entertainment system configured and optimized on your device.'
    },
    {
      question: 'How do I renew my subscription?',
      answer: 'The renewal process is manual, not automatic. Before your subscription expires, we will send you an email reminder about the renewal. You have complete autonomy to decide whether to renew your subscription.'
    },
    {
      question: 'Do you take recurring payments?',
      answer: 'Our service does not support recurring payments. Rest assured, you will not be automatically charged by Goodys Streams. Whenever your service is nearing its expiration, our system will send you a reminder email.'
    },
    {
      question: 'Can I get a refund?',
      answer: 'Before requesting a refund, have you considered reaching out to our customer support? For a "3 Months Subscription," you are eligible for a refund if requested within 7 days. For a "6 Months Subscription" or longer, you are eligible for a refund if requested within 30 days from the payment date.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Questions?</h2>
          <h3 className="text-xl text-orange-500 font-semibold">We've got answers.</h3>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-white/5 transition-colors cursor-pointer"
              >
                <span className="font-semibold">{faq.question}</span>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-300">If you need further information, please contact us.</p>
        </div>
      </div>
    </section>
  );
}
